<template>
    <div id="products-container" class="block-type-container" name="luts-you-own-container">

        <div v-for="block in creativeBlocks" :key="block.name" @click="selectBlock(block)" class="control-name"
             style="grid-template-columns: 1fr; width: 100%" data-name="product-block">
            <div class="control-label d-flex align-center justify-space-between">
                <span>{{ block.label }}</span>
            </div>
        </div>

        <div v-for="product in products" :key="product" @click="selectProduct(product)" class="control-name"
             style="grid-template-columns: 1fr; width: 100%" data-name="product-block">
            <div class="control-label d-flex align-center justify-space-between">
                <span>{{ product }}</span>
            </div>
        </div>

        <template v-if="isPlanProfessional">
            <span class="type-title mt-5">Custom 3D LUTs</span>

            <div v-for="block in controlBlocks" :key="block.name" @click="selectBlock(block)" class="control-name"
                 style="grid-template-columns: 1fr; width: 100%" data-name="product-block">
                <div class="control-label d-flex align-center justify-space-between">
                    <span>{{ block.label }}</span>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import config from '@/assets/js/config/Config';

export default {
    async mounted() {
        await this.$store.dispatch('Products/fetch');
    },

    computed: {
        ...mapState('UI', ['startTipsStep']),
        ...mapState('Projects', ['image']),
        ...mapState('Products', ['products']),
        ...mapState('User', ['user', 'account']),
        ...mapGetters('User', ['isPlanProfessional']),
        config() {
            return config;
        },
        controlBlockType() {
            return this.config.blocks.find(blockType => blockType.type == 'control');
        },
        controlBlocks() {
            return this.controlBlockType?.controls;
        },
        creativeBlockType() {
            return this.config.blocks.find(blockType => blockType.type == 'creative-block');
        },
        creativeBlocks() {
            return this.creativeBlockType?.controls;
        }
    },

    methods: {
        selectProduct(product) {
            const data = {
                control: 'LUTcontrols',
                category: product,
                initial: true,
                product,
            };

            this.addBlock(data);
        },

        selectBlock(block) {
            const data = {
                control: block.name,
                ...(block.category) && { category: block.category },
                initial: true,
            };

            this.addBlock(data);
        },

        async addBlock(blockData) {
            if (this.$store.state.App.blockLoading) return;
            UI.hideBlockSelectorMenu();

            await _Adjustments[blockData.control].addBlock(blocks.getNewBlockNumber(), blockData);
            lutify.storeLastState();

            if (lutify.activeSidebarContainer !== 'blocks') {
                UI.container.sidebarSelector.find('[data-container="blocks"]').trigger('click');
                UI.scrollToBlock(lutify.activeBlock);
            }
        }
    }
};
</script>
